module.exports = __webpack_public_path__ + "static/media/bg6.b937d41a.png";